import { MantineProvider, createTheme } from '@mantine/core';
import '@mantine/core/styles.css';
import { Notifications } from '@mantine/notifications';
import '@mantine/notifications/styles.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './hooks/useAuth';
import { ServerStatusProvider } from './contexts/ServerStatusContext';
import { LanguageProvider } from './contexts/LanguageContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';

// Create a theme
const theme = createTheme({
  // You can customize your theme here
});

// Create a query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <MantineProvider theme={theme}>
        <Notifications position="top-right" />
        <BrowserRouter>
          <AuthProvider>
            <ServerStatusProvider>
              <LanguageProvider>
                <Routes>
                <Route 
                  path="/" 
                  element={
                    <PrivateRoute>
                      <Layout>
                        <DashboardPage />
                      </Layout>
                    </PrivateRoute>
                  } 
                />
                <Route path="/login" element={<LoginPage />} />
                </Routes>
              </LanguageProvider>
            </ServerStatusProvider>
          </AuthProvider>
        </BrowserRouter>
      </MantineProvider>
    </QueryClientProvider>
  );
}

export default App;
